import * as React from 'react';
import { PremiumCurrencyFormatter } from '@wix/premium-react-text';
import s from './Cycles.scss';
import { Text } from 'wix-style-react';
import classNames from 'classnames';
import { Translation } from 'react-i18next';

interface IFullPrice {
  Monthly: React.FC<{
    monthlyFullPrice: number;
    className: string;
    hideZeroDecimals?: boolean;
  }>;
  Brazil: React.FC<{ actualPrice: number }>;
  BrazilSale: React.FC<{ fullPrice: number }>;
}

export const MonthlyComp = ({
  monthlyFullPrice,
  className,
  hideZeroDecimals = false,
}) => (
  <PremiumCurrencyFormatter
    render={(formatCurrency) => (
      <Text weight='thin'>
        <span
          data-hook='cycle-full-price'
          className={classNames(s.cycleSaleFullpriceText, className)}
        >
          {formatCurrency(monthlyFullPrice, { hideZeroDecimals })}
        </span>
      </Text>
    )}
  />
);

const BrazilComp = ({ actualPrice }) => (
  <Translation>
    {(t) => (
      <PremiumCurrencyFormatter
        render={(formatCurrency) => (
          <>
            {t('cycle_entry.cycle_price.in_cash', {
              fullPrice: formatCurrency(actualPrice),
            })}
            <br />
          </>
        )}
      />
    )}
  </Translation>
);

const BrazilSaleComp = ({ fullPrice }) => (
  <Translation>
    {(t) => (
      <PremiumCurrencyFormatter
        render={(formatCurrency) => (
          <>
            <span className={s.fullPriceWrapper}>
              {formatCurrency(fullPrice, { hideZeroDecimals: true })}
            </span>
            &nbsp;
          </>
        )}
      />
    )}
  </Translation>
);

export const FullPrice: IFullPrice = {
  Monthly: MonthlyComp,
  Brazil: BrazilComp,
  BrazilSale: BrazilSaleComp,
};
